module.exports = __webpack_public_path__ + "media/jq_pano.8cac6060.mp4";